import classNames from 'classnames';
import React, { createRef, useEffect } from 'react';
import ToggleChapter from '../ToggleChapter';
import View from './view';

const Chapter = (props) => {
  const content = createRef(null);
  function fitInWidth() {
    if (content.current === null) {
      return null;
    }
    const elements = content.current.querySelectorAll('.table-wrapper-inner');
    for (let i = 0; i < elements.length; i++) {
      const wideTable = elements[i].className.indexOf('wide');

      const offsetWidth = elements[i].offsetWidth;

      // If tables width is greater than scrollwidth it should have overflow
      if (offsetWidth < elements[i].scrollWidth) {
        // If table has class .wide, eg is not -1, set classes for overflow AND for wide
        if (wideTable !== -1) {
          elements[i].parentNode.className =
            'table-wrapper table-wrapper--is-wide table-wrapper--is-overflow';
        } else {
          elements[i].parentNode.className =
            'table-wrapper table-wrapper--is-overflow';
        }
      }
    }
  }

  function wrapTables() {
    if (!props.ContentString || content.current === null) {
      return null;
    }

    const table = content.current.querySelectorAll('table');
    if (table.length === 0) return;

    for (var i = 0; table.length - i; i++) {
      const parent = table[i].parentNode;

      if (parent.parentNode.className.indexOf('table-wrapper-inner') > -1)
        continue;

      const wrapper = document.createElement('div');
      wrapper.className = 'table-wrapper';

      const tableWrapper = document.querySelectorAll('.table-wrapper');
      const wrapperInner = document.createElement('div');
      const innerTableWrapper = document.createElement('div');
      const tableClasses = table[i].className;
      wrapperInner.className = `table-wrapper-inner ${tableClasses}`;
      tableWrapper.className = `table-wrapper ${tableClasses}`;

      // insert wrapper before el in the DOM tree
      parent.insertBefore(wrapperInner, table[i]);
      innerTableWrapper.appendChild(table[i]);
      wrapperInner.appendChild(innerTableWrapper);
      parent.insertBefore(wrapper, wrapperInner);
      wrapper.appendChild(wrapperInner);
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.requestAnimationFrame(() => {
        wrapTables();
        fitInWidth();
      });
    }
  }, []);

  const hasInlineImage =
    props.ImageProperties === 'mini' ||
    props.ImageProperties === 'mini-reverse' ||
    props.ImageProperties === 'xsmall' ||
    props.ImageProperties === 'xsmall-reverse';

  const dataPrintSidebarTitle = props.Heading || '';

  const headingLevel = (() => {
    const inheritedLevel = props.headingLevel;
    const parentHasHeading = !!props.isH3;
    const hasHeading = !!props.Heading;

    if (!hasHeading) return null;

    if (inheritedLevel !== undefined) {
      return inheritedLevel;
    }

    if (parentHasHeading === true) {
      return 3;
    }

    return 2;
  })();

  return (
    <div
      ref={content}
      className={classNames('c-chapter', {
        'c-chapter--inline-image': hasInlineImage,
        'c-chapter--regional-content': props?.regionalName,
      })}
      id={props.AnchorSectionId}
      data-print-sidebar-title={dataPrintSidebarTitle}
      data-print-sidebar-title-region={props?.regionalName ?? ''}
      data-is-member-of-chapter-container={
        props.isMemberOfChapterContainer || 'false'
      }
      data-is-chapter={'isChapter'}
    >
      {!props.noToggle &&
      props.Heading &&
      props.AnchorSectionId &&
      !props.isH3 &&
      !props.CurrentPageProps.Content.HideAnchorNavigation &&
      !props.HideAnchorLink &&
      (props.renderRegionAsExpandable ?? true) ? (
        <ToggleChapter
          Heading={props.Heading}
          id={props.UniqueBlockId}
          AnchorSectionId={props.AnchorSectionId}
          regionalContainer={props?.regionalName}
          headingLevel={headingLevel}
        >
          <View
            {...props}
            chapterIsInExpandable
            regionalContainer={props?.regionalName}
          />
        </ToggleChapter>
      ) : (
        <View
          {...props}
          headingLevel={headingLevel}
          regionalContainer={props?.regionalName}
        />
      )}
    </div>
  );
};

export default Chapter;
